import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaign-event-builder',
  templateUrl: './campaign-event-builder.component.html',
  styleUrls: ['./campaign-event-builder.component.css']
})
export class CampaignEventBuilderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
